import React from "react";
import CreateWorkflowComponent from "../features/workflows-page/createWorkflow/CreateWorkflow";

const CreateWorkflow = () => {
  return <CreateWorkflowComponent />;
};

export default CreateWorkflow;
